import { CALYPSO_DARK, MARIGOLD_DARK, NORMAN, OZ_DARK, SORBET_DARK, THUNDERDOME_DARK } from 'HubStyleTokens/colors';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
export const ProductLineToColor = {
  [MARKETING]: CALYPSO_DARK,
  [SALES]: OZ_DARK,
  [SERVICE]: THUNDERDOME_DARK,
  [OPERATIONS]: MARIGOLD_DARK,
  [CMS]: SORBET_DARK,
  [COMMERCE]: NORMAN
};